import { Injectable } from '@angular/core';


export class AlertConfig {
  /** default alert type */
  type = 'warning';

  /** is alerts are dismissible by default */
  dismissible = false;

  /** default time before alert will dismiss */
  dismissOnTimeout?: number = undefined;
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../.tmp/alert/alert.config.ts